module.exports = __webpack_public_path__ + "media/points/generate-a74538ae.svg";